<template>
  <div>
    <CRow class="mb-4">
      <CCol>
        <CCard class="bg-style2">
          <CCardHeader class="bg-gradient-danger text-white" style="border-top-left-radius: 1rem; border-top-right-radius: 1rem ">
            <span className="font-weight-bold h6"><CIcon name="cil-layers" size="lg"/> {{ caption }}</span>
          </CCardHeader>
          <CCardBody>
            <CRow>
              <CCol col="12">
                <CSelect
                    label="Organization"
                    :horizontal="{label: 'col-sm-3', input: 'col-sm-9 pl-2'}"
                    :options="organizations"
                    @update:value="onSelectOrganizations"

                />
              </CCol>
              <CCol col="12">
<!--                <CSelect-->
<!--                    label="Agency"-->
<!--                    :horizontal="{label: 'col-sm-3', input: 'col-sm-9'}"-->
<!--                    :options="agencys"-->
<!--                    @update:value="onSelectAgencys"-->
<!--                />-->

                <CRow>
                  <CCol col="3">
                    <label>Agency</label>
                  </CCol>
                  <CCol>
                    <Multiselect class="os"
                                 v-model="agencySelect"
                                 :options="agencys"
                                 label="label"
                                 track-by="label"
                                 :multiple="false"
                                 :search="true"
                    >
                    </Multiselect>
                  </CCol>
                </CRow>



              </CCol>
              <CCol col="12" v-if="!disable">
                <CInput :label="$t('academicYear')"
                        type="number"
                        :horizontal="{label: 'col-sm-3', input: 'col-sm-9'}"
                        v-model="option.year"/>

              </CCol>
<!--              <CCol col="6">-->
<!--                <CSelect :label="$t('semester')"-->
<!--                         :disabled="disable"-->
<!--                         :horizontal="{label: 'col-sm-3', input: 'col-sm-9'}"-->
<!--                         @update:value="onSemester"-->
<!--                         :options="semesters"/>-->
<!--              </CCol>-->
            </CRow>
          </CCardBody>
        </CCard>
      </CCol>
    </CRow>

  </div>
</template>

<script>


import {mapGetters} from 'vuex'
import Multiselect from 'vue-multiselect'
import 'vue-multiselect/dist/vue-multiselect.min.css'

export default {
  name: 'FilterOrganization',
  components: {Multiselect},
  props: {
    caption: {
      type: String,
      default: ""
    },
    disable: {
      type: Boolean,
      default: false
    },
    option: {
      type: Object,
      default: {}
    }
  },
  data: function () {
    return {
      campus: [],
      semesters: [
        {
          label: " 1",
          value: 1
        }, {
          label: " 2",
          value: 2
        }, {
          label: " 3",
          value: 3
        }
      ],
      course: [],
      organizations:[],
      agencys:[],
      agencySelect :""


    }


  },

  mounted() {
  },

  created() {
    this.onInit()

  },
  beforeDestroy() {

  },

  methods: {
    onInit() {

      this.$store.dispatch("organization/config",{})
      this.$store.dispatch("agency/config",{})

    },


    onSelectOrganizations(value, e) {
      this.option.campusId = value;
      this.$emit("option", this.option)
    },

    onSelectAgencys(value, e) {
      this.option.agency = value;
      this.$emit("option", this.option)
    },


  },


  computed: {
    ...mapGetters({
      lang: 'setting/lang',
      organization: 'organization/organization',
      agency: 'agency/item',
    }),
  },

  watch: {
    organization: function (value) {

      this.organizations = [];
      var lang = this.$store.getters['setting/lang']
      var items = [];
      value.filter(item => {
        var objs = item.title.filter(title => {
          if (title.key == lang) {
            return title
          }
        })[0].value;
        var data = {};
        data.label = objs
        data.value = item._id;
        items.push(data)
      })
      this.organizations = items;
    },
    agency: function (value) {

      this.agencys = [];
      var lang = this.$store.getters['setting/lang']
      var items = [];
      var data = {};
      data.label = "-"
      data.value = 0
      items.push(data)

      value.filter(item => {
        var objs = item.title.filter(title => {
          if (title.key == lang) {
            return title
          }
        })[0].value;
        var data = {};
        data.label = objs
        data.value = item._id;
        items.push(data)
      })
      this.agencys = items;

      // var body = {};
      // body.agency = this.agencys[0].value;
    },

    agencySelect(value){
      this.option.agency = value.value;
      this.$emit("option", this.option)
    }
  }

}
</script>
<style>


</style>
